import Vue from "vue";
import moment from "moment";


const store = Vue.observable({
    fleetData: {
        loaded: false,
        test: false,
        contractSelected: [],
        filterSelected: 'all',
        filterSelectedAdditional: '',
        openNewTicket: false,
        data: {
            contracts: []
        },
        eventsHistory: {},
        currentEventsHistory: [],
        version: '2.1.0'
    },
    messages: {
        loaded: false,
        data: []
    }
});

const actions = {
    async getFleet() {
        let result;
        store.fleetData.loaded = false;
        try {
          result = await Vue.axios.get(`fleet`);
        }
        catch(err) {
          result = err;
        }
        if (!result || !result.contracts ) return;
        store.fleetData.data = result;
        store.fleetData.loaded = true;
        flagFleet();
    },
    async modify(vehicleId, changes) {
        let result;
        let data = {
            vehicleId,
            changes
        }
        try {
          result = await Vue.axios.put(`fleet/vehicle`, data);
        }
        catch(err) {
          result = err;
          return err;
        }
        return;
    },
    async createTicket(data, vehicleId) {
        let result;

        data.type = data.ticketType;
        delete data.ticketType;

        try {
          result = await Vue.axios.post(`fleet/createTicket`, {data: data, vehicleId});
        }
        catch(err) {
          result = err;
          return err;
        }
        return result;

    },
    async getVehicleEventsHistory( ugpId ) {

      console.log("REAL API call ", ugpId )
      let result;

      try {
        result = await Vue.axios.get(`fleet/vehicleEventsHistory?ugpId=${ugpId}`);
      }
      catch(err) {
        result = err;
        return err;
      }

      return result;

  },

    

    async sendMileage(mileage, vehicleId) {
        let result;

        try {
          result = await Vue.axios.post(`fleet/newMileage`, {mileage, vehicleId});
        }
        catch(err) {
          result = err;
          return err;
        }
        return result;

    },
    async downloadFleetXls() {
        const link = document.createElement('a');
        link.href = `/api/fleet?format=xls`;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
    },
    async sendActivity(text, ticketId, flatEntityId, isTicket) {
      console.log('api sendActivity');
      let result;
      try {
        result = await Vue.axios.post(`fleet/new_activity`, {text, ticketId, isTicket});
      }
      catch(err) {
        result = err;
      }
      console.log('api resp', result);
      if (result && result.status && result.status === 'success' && result.activity) {
          store.fleetData.data.contracts.find(c => c._id === flatEntityId).tickets.find(t => t._id === ticketId).activities.push(result.activity);
          return;
      }
      if (result && result.info && result.info.message) return result.info.message;
      return 'error'
    },
    async getMessages() {
      let result;
      store.messages.loaded = false;
      try {
        result = await Vue.axios.get(`fleet/messages`);
      }
      catch(err) {
        result = err;
      }
      if (!result) return;
      store.messages.data = result;
      store.messages.loaded = true;
    },

    async markMessageAsRead(messageId) {
      let result;
      try {
        result = await Vue.axios.put(`fleet/messages`, {messageId});
      }
      catch(err) {
        return err;
      }
      if (!result || !result.status || !result.status === 'success') return result || 'missing response';
  }
}

const mutations = {
    getFiltered(filter = store.fleetData.filterSelected) {
      store.fleetData.data.contracts.forEach(contract => {
        if ( filter === 'all' ) contract.active = true;
        else if ( filter === 'terms' ) contract.active = !!contract['registrationExpiring'] || !!contract['insuranceExpiring'] || !!contract['kaskoExpiring']
        else {
          contract.active = !!contract[filter]
        }
      });
      return store.fleetData.data.contracts.sort(function (a, b) { return b.active - a.active})

    }
}

const flagFleet = () => {
  let dateNow = moment();

  store.fleetData.data.contracts.forEach(contract => {

    contract.active = true;

    // flag contractExpiring
    let dateExpiring = moment(contract.najam._end);
    if ( dateExpiring.diff(dateNow, 'days') < 30 ) contract.contractExpiring = true;

    // flag registrationExpiring
    dateExpiring = moment(contract.auto.registrationEndDate);
    if ( dateExpiring.diff(dateNow, 'days') < 30 ) contract.registrationExpiring = true;
    // flag insuranceExpiring
    dateExpiring = moment(contract.auto.istekOsig);
    if ( dateExpiring.diff(dateNow, 'days') < 30 ) contract.insuranceExpiring = true;
    // flag kaskoExpiring
    dateExpiring = moment(contract.auto.istekOsigk);
    if ( dateExpiring.diff(dateNow, 'days') < 30 ) contract.kaskoExpiring = true;

    // flag mileage missing
    let lastMileage = contract.mileage && contract.mileage.lastDocumentedMileage ? moment(contract.mileage.lastDocumentedMileage.mileageDate.sec * 1000) : null;
    contract.daysSinceLastReading = lastMileage ? moment().diff(lastMileage, 'days') : null;
    if (contract.daysSinceLastReading === null || contract.daysSinceLastReading > 30) contract.mileageMissing = true;

    // flag ticketInProgress
    let hasActive = false;
    contract.tickets.forEach(ticket => {
      if (ticket.metadata.status !== 'resolved') return hasActive = true;
    });
    if (hasActive) contract.ticketInProgress = true;

  });

}

export default {
    store,
    actions,
    mutations
}
